import { render, staticRenderFns } from "./myTicketGift.vue?vue&type=template&id=f8911ae0&scoped=true&"
import script from "./myTicketGift.vue?vue&type=script&lang=js&"
export * from "./myTicketGift.vue?vue&type=script&lang=js&"
import style0 from "./myTicketGift.vue?vue&type=style&index=0&id=f8911ae0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8911ae0",
  null
  
)

export default component.exports